module.exports = __webpack_public_path__ + "img/value.4f457fb2.png";